import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import '../../assets/scss/sub-nav.scss';

const TrainingNav = () => {

  const scrollPage = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="fiterr-app-section sub-nav">
      <div className="fiterr-app-inner-wrapper">
        <div className="fiterr-app-sub-nav">
          <Link onClick={scrollPage} className="navbar-btn" to='/training/overview'>
            <div className="btn-label">overview</div>
          </Link>
          <Link onClick={scrollPage} className="navbar-btn" to='/training/calendar'>
            <div className="btn-label">calendar</div>
          </Link>
          <Link onClick={scrollPage} className="navbar-btn" to='/training/programs'>
            <div className="btn-label">programs</div>
          </Link>
          <Link onClick={scrollPage} className="navbar-btn" to='/training/workouts'>
            <div className="btn-label">workouts</div>
          </Link>
          <Link onClick={scrollPage} className="navbar-btn" to='/training/exercise-library'>
            <div className="btn-label">exercise library</div>
          </Link>
          <Link onClick={scrollPage} className="navbar-btn" to='/training/settings'>
            <div className="btn-label">settings</div>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default withRouter(TrainingNav);